import React from 'react'
import classNames from 'classnames'
import StringInput from '../inputs/StringInput'

export default function PrefixStringField(props: PrefixStringFieldProps) {
  const {
    label,
    prefix,
    required,
    error,
    register,
    name,
    type,
    placeholder,
    ariaLabel,
    information,
    disabled = false
  } = props

  return (
    <>
      <label htmlFor={name} className="block text-sm font-medium leading-5 text-gray-700">
        {label} {required && '*'}
      </label>
      <div className="mt-1 flex">
        <span className="inline-flex items-center leading-3 px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
          {prefix}
        </span>
        <StringInput
          register={register}
          ariaLabel={ariaLabel}
          name={name}
          disabled={disabled}
          type={type}
          placeholder={placeholder}
          className={classNames(
            'rounded-l-none transition duration-150 ease-in-out',
            !!error && 'border-red-600 focus:border-red-300',
            disabled && 'opacity-50 cursor-not-allowed',
          )}
        />
      </div>
      {information && <p className="mt-1 text-sm text-gray-500">{information}</p>}
      {!!error && (
        <p className="mt-1 text-sm text-red-600" id={`${name}-error`}>
          {error.message}
        </p>
      )}
    </>
  )
}

interface PrefixStringFieldProps {
  register: React.Ref<HTMLInputElement>
  label: string
  prefix: string
  required?: boolean
  information?: string
  name: string
  type?: string
  placeholder?: string
  ariaLabel?: string
  error?: { message?: string }
  disabled?: boolean
}
